module.exports = __webpack_public_path__ + "img/public_wuan.38ef7b88.png";